<template>
  <section :id="rootElementId">
    <h3 class="text-h5 mb-6 text-md-h4 mb-md-12">
      Расширяйте бизнес с телемед-консультациями
    </h3>

    <TelemedCarousel class="mb-8" />

    <v-row>
      <v-col
        v-for="item in telemedFeatures"
        :key="item.title"
        :cols="$display.mdAndUp.value ? 3 : 12"
      >
        <v-sheet
          color="ui-kit-bg-secondary"
          class="pa-6 rounded-xl"
          elevation="0"
          height="100%"
        >
          <v-sheet
            width="36"
            height="36"
            class="d-flex justify-center align-center mb-4 bg-primary rounded-circle"
          >
            <v-icon
              size="20"
              class="bg-primary text-ui-kit-bg-gray-0 rounded-circle"
            >
              {{ item.icon }}
            </v-icon>
          </v-sheet>

          <div :class="$display.mdAndUp.value ? 'text-body-1' : 'landing-subtitle-1'">
            {{ item.title }}
          </div>
        </v-sheet>
      </v-col>
    </v-row>

    <v-sheet
      class="mt-4 bordered-sheet rounded-xl pa-6 d-flex align-center flex-column flex-md-row"
      elevation="0"
    >
      <p
        class="flex-grow-1 ma-0"
        :class="$display.mdAndUp.value ? 'landing-card-title-1' : 'landing-subtitle-1'"
      >
        Как извлечь максимум выгоды — в курсе<br />
        «Основы телемедицины для практикующего врача»
      </p>

      <LandingFeatureBtn
        breakpoint="md"
        class="mt-8 mt-md-0"
        text="Пройти курс"
        width="205"
        href="https://academy.medrocket.ru/course/view.php?id=37"
        target="_blank"
        variant="tonal"
      />
    </v-sheet>

    <div class="mt-4 mt-md-12 d-flex justify-center">
      <LandingFeatureBtn
        variant="tonal"
        width="422"
        :text="telemedButtonText"
        @click="$emit('click')"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import { useDisplay } from 'vuetify'
import TelemedCarousel from '~/features/Home/components/FeaturesSection/ClinicFeatures/TelemedCarousel.vue'

const emit = defineEmits(['click'])

const telemedFeatures = [
  {
    icon: 'ui-icon-user-add',
    title: 'К вашим специалистам смогут записаться пациенты из других городов',
  },
  {
    icon: 'ui-icon-home-MedLock',
    title: 'Проводите консультации с заботой о пациентах: они смогут экономить время на дорогу, задавать врачу вопросы, откуда удобно, и обращаться чаще',
  },
  {
    icon: 'ui-icon-time-circle-half',
    title: 'Доктору больше не придётся давать свой номер телефона и бесплатно работать с пациентами в нерабочее время, при этом клиника сохранит сервис на высоком уровне',
  },
  {
    icon: 'ui-icon-circle-close',
    title: 'Если пациент не оплатит консультацию в течение 20 минут после записи, она автоматически отменится',
  },
]
const rootElementId = 'feature-telemed'

const $display = useDisplay()
const $route = useRoute()

const telemedButtonText = computed(() =>
  $display.mdAndUp.value ? 'Подключить Телемедицину МедРокет' : 'Подключить Телемедицину',
)

onMounted(() => {
  if (import.meta.server) {
    return
  }

  if ($route.hash === `#${rootElementId}`) {
    emit('click')
  }
})
</script>
